import { ICourse } from 'interface/course';
import { BUILD_NUMBER, SOCKET_LOGGING } from 'settings';
import { emitLog } from 'services/socket';

export function upsSendJudas(data: {
  action: string;
  id: number;
  hash_checkout: string;
  viewd: string;
  producer_id: number;
  user_id: number;
}) {
  return async () => {
    return sendLog('upsellnew', {
      action: data.action,
      ups_code: data.id,
      ups_checkout: data.hash_checkout,
      ups_viewd: data.viewd,
      ups_usr: data.producer_id,
      ups_learner: data.user_id,
    });
  };
}

export function viewBanner(data: { id: number; url: string }) {
  return async () => {
    return sendLog('banner', {
      action: 'view',
      banner_id: data.id,
      banner_url: data.url,
    });
  };
}

export function clickBanner(data: { id: number; url: string }) {
  return async () => {
    return sendLog('banner', {
      action: 'click',
      banner_id: data.id,
      banner_url: data.url,
    });
  };
}

export function clickCertificate(data: { hash: string; progress: number; version: string }) {
  return async () => {
    return sendLog('certificate', {
      action: 'click',
      cou_hash: data.hash,
      progress: data.progress,
      version: data.version,
    });
  };
}

export function viewCourseOffer(course: ICourse) {
  return async () => {
    return sendLog('courseOffer', {
      action: 'view',
      course_id: course.id,
      course_hash: course.hash,
      offer_id: course.offer,
      offer_url: course.offer_url,
    });
  };
}

export function clickCourseOffer(course: ICourse) {
  return async () => {
    return sendLog('courseOffer', {
      action: 'click',
      course_id: course.id,
      course_hash: course.hash,
      offer_id: course.offer,
      offer_url: course.offer_url,
    });
  };
}

function sendLog(area: string, data: any) {
  if (!SOCKET_LOGGING) return;
  emitLog(data, `nutror.front.${area}`, `nutrorv3`);
}

export function sendElastic(
  action: string,
  message: string,
  data?: {
    courseHash?: string;
    courseId?: number;
    lessonId?: number;
    data?: object;
    status?: string;
  }
) {
  if (!SOCKET_LOGGING) return;
  const dataLog = !data?.data
    ? ({
      action,
      message,
      referer: window.location.href,
      course_hash: data?.courseHash,
      course_id: data?.courseId,
      lesson_id: data?.lessonId,
      status: data?.status,
      version: BUILD_NUMBER,
    } as any)
    : ({
      action,
      message,
      referer: window.location.href,
      data: data?.data,
      version: BUILD_NUMBER,
    } as any);

  return emitLog(dataLog, `nutror.user.${action}`, 'nutror-activity');
}
